import styled from 'styled-components'
import Button from 'components/Button/Button'
import { Field } from 'formik'
import { themeGet } from 'styled-system'
import AutoTable from 'components/AutoTable'

export const SubmitButton = styled(Button)`
  margin: 5px;
  background-color: #002855;
`

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`

export const TextareaWrapper = styled.div`
  margin: 1rem 0;
  width: 50%;
`

export const StyledTextarea = styled(Field)`
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  &:disabled {
    background-color: #e9ecef;
    opacity: 1;
  }

  &.is-invalid {
    border-color: #dc3545;
  }
`

export const ResultsSection = styled.div`
  margin: 2rem 0;
  max-height: 500px;
  overflow-y: auto;

  & a {
    color: ${themeGet('colors.blue')};
  }

  & a:hover {
    color: ${themeGet('colors.darkBlue')};
  }
`

export const StyledAutoTable = styled(AutoTable)`
  margin-top: 1rem;
`

export const TemplateLinkWrapper = styled.div`
  a {
    color: ${themeGet('colors.blue')};
  }
`

export const ErrorMessage = styled.div`
  color: ${themeGet('colors.error') || '#dc3545'};
  margin: 1rem 0;
  padding: 0.75rem;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 0.25rem;
`
